import ComponentView from '../../dom_components/view/ComponentView';
import ComponentDataCondition from '../model/conditional_variables/ComponentDataCondition';

export default class ComponentDataConditionView extends ComponentView<ComponentDataCondition> {}
